/**
 * Created by rjulius on 2/9/16.
 */
import View from "app/core/View";
import template from "common/forms/ExternalFormsView.html";
import DisplayView from "common/forms/FormsDisplayView.html";
import ViewModel from "app/forms/ExternalFormsViewModel";
import "common/widgets/LoadingBar/LoadingBar";
import "common/bindings/preloader";
import "common/bindings/reference";
import "common/bindings/readonly";
import "common/bindings/attr";
import "common/bindings/classWhen";
import "common/bindings/enter";
import "common/bindings/theme";
import "app/widgets/PromptList/CustomPromptList";
import "app/widgets/Message/Message";

export default View.extend({

    init: function() {
        var viewModel = new ViewModel();
        View.fn.init.call(this, template.replace('<div id="formsDisplay" class="full-height"></div>', DisplayView), {
            model: viewModel,
            wrap: false,
            shouldContainerScroll: false,
            show: $.proxy(viewModel.onShow, viewModel),
            init: $.proxy(viewModel.onInit, viewModel),
            hide: $.proxy(viewModel.onHide, viewModel)
        });
    }

});
